import dayjs from 'dayjs';

export function createdAtToDueAt(createdAt: string): string {
  return dayjs(createdAt)
    .add(7, 'day')
    .format('M月D日');
}
